import { SERIES, OTHER } from '../components/charts';

/** Two colours a reader could mix up (plain RGB distance — close enough for picking a free series colour). */
export function nearColor(a, b) {
  const rgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
  const [x, y] = [rgb(a), rgb(b)];
  return Math.hypot(x[0] - y[0], x[1] - y[1], x[2] - y[2]) < 90;
}

/**
 * One colour per id for a single chart / map, busiest first: an id keeps its own colour (a job's) unless a busier id
 * already has a look-alike, then the next free series colour; past the series, Other. Identity never collides.
 */
export function distinctColors(ids, ownColor = () => null) {
  const m = new Map(); const used = [];
  const clash = (c) => used.some((u) => nearColor(u, c));
  for (const id of ids) {
    const own = ownColor(id);
    const c = own && /^#[0-9a-f]{6}$/i.test(own) && !clash(own) ? own : SERIES.find((s) => !clash(s)) || OTHER;
    used.push(c); m.set(id, c);
  }
  return m;
}
